import { FormControl, InputLabel, OutlinedInput } from '@mui/material';
import NumberFormatRands from '../../NumberFormatRands';
import { UnsavedAdornment } from '../UnsavedIcon';
import { getFieldControlSx } from '../fieldStyles';
import type { FieldRendererProps } from '../types';

export function CurrencyField({
  field,
  className,
  sx,
  hasWhiteFields = false,
  isDisabled,
  isUnsaved,
  autoFocus,
  onChange,
}: FieldRendererProps) {
  return (
    <FormControl fullWidth required={field.required}>
      <InputLabel htmlFor="component-outlined">{field.label}</InputLabel>
      <OutlinedInput
        id={field.id.toString()}
        key={field.id}
        label={field.label}
        value={field.value}
        disabled={isDisabled}
        autoFocus={autoFocus}
        onChange={(event) => onChange(event.target.value)}
        sx={getFieldControlSx(hasWhiteFields, sx)}
        className={className}
        size="small"
        margin="dense"
        inputComponent={NumberFormatRands as any}
        endAdornment={isUnsaved ? <UnsavedAdornment /> : undefined}
      />
    </FormControl>
  );
}
